/**
 * Utilitário para identificar o ambiente atual
 */

/**
 * Identifica o ambiente atual baseado na URL da API
 * @returns {string} O prefixo do ambiente (Local, DEV, Homolog) ou string vazia para produção
 */
export const getEnvironmentPrefix = () => {
  const apiUrl = process.env.REACT_APP_AXIOS_BASE_URL;
  
  // Verifica o ambiente com base na URL da API
  if (apiUrl.includes('127.0.0.1') || apiUrl.includes('localhost')) {
    return 'Local';
  } else if (apiUrl.includes('dev') || apiUrl.includes('desenvolvimento')) {
    return 'DEV';
  } else if (apiUrl.includes('homolog') || apiUrl.includes('homologacao')) {
    return 'Homolog';
  }
  
  // Em produção, retorna string vazia
  return '';
};

/**
 * Retorna o título completo para o navegador
 * @returns {string} Título formatado com prefixo do ambiente, se aplicável
 */
export const getPageTitle = () => {
  const prefix = getEnvironmentPrefix();
  return prefix ? `${prefix} - Pedagogia` : 'UniChristus';
};
